var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.failed && _vm.isValidated)?_c('base-alert',{staticClass:"text-center",attrs:{"type":"danger"}},[_c('div',[_vm._v("There are questions which require responses before proceeding.")]),_c('div',[_vm._v("The unanswered questions are highlighted above.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }